// @flow
import styled from 'styled-components';
import { Icon } from '../core/Icon';

export const BookmarkSolidIcon = styled(Icon)``;
export const BookmarkOutlineIcon = styled(Icon)``;
export const XIcon = styled(Icon)``;

BookmarkSolidIcon.defaultProps = { uri: 'icn-bookmark-on.svg' };
BookmarkOutlineIcon.defaultProps = { uri: 'icn-bookmark-off.svg' };
XIcon.defaultProps = { uri: 'icn-x-plain.svg' };
